import { concat, of } from 'rxjs';

import { actions as bootstrapActions } from '@ezugi/bootstrap';
import { CANCEL_ROUND } from '@ezugi/constants';

import { cardsActions } from '../../reducers/cards';

const {
  configActions,
  roundActions: { round },
  betActions: { history },
  uiActions: { progressBar, myBets },
} = bootstrapActions;

const handleCancelRound = () => concat(
  // additional bet.reset() is triggered by @ezugi/bootstrap
  of(round.set({
    roundStatus: CANCEL_ROUND,
    roundSkippedPYB: false,
  })),
  of(progressBar.reset()),
  of(myBets.highlight(false)),
  of(history.reset()),
  of(cardsActions.cards.reset()),
  of(configActions.config.set({ payoutsProgress: {} })),
);

export default handleCancelRound;
